/* eslint-disable */
/* prettier-ignore */
// Generated by elegant-router
// Read more: https://github.com/soybeanjs/elegant-router

import type { GeneratedRoute } from '@elegant-router/types';

export const generatedRoutes: GeneratedRoute[] = [
  {
    name: '403',
    path: '/403',
    component: 'layout.blank$view.403',
    meta: {
      title: '403',
      keepAlive: true,
      i18nKey: 'route.403',
      constant: true
    }
  },
  {
    name: '404',
    path: '/404',
    component: 'layout.blank$view.404',
    meta: {
      title: '404',
      keepAlive: true,
      i18nKey: 'route.404',
      constant: true
    }
  },
  {
    name: '500',
    path: '/500',
    component: 'layout.base$view.500',
    meta: {
      title: '500',
      i18nKey: 'route.500',
      constant: true
    }
  },
  {
    name: 'coupon-detail',
    path: '/coupon-detail',
    component: 'layout.base$view.coupon-detail',
    meta: {
      title: 'coupon-detail',
      i18nKey: 'route.coupon-detail'
    }
  },
  {
    name: 'coupon-list',
    path: '/coupon-list',
    component: 'layout.base$view.coupon-list',
    meta: {
      title: 'coupon-list',
      i18nKey: 'route.coupon-list'
    }
  },
  {
    name: 'login',
    path: '/login/:module(pwd-login|code-login|register|reset-pwd|bind-wechat)?',
    component: 'layout.base$view.login',
    props: true,
    meta: {
      title: 'login',
      i18nKey: 'route.login',
      constant: true
    }
  },
  {
    name: 'query',
    path: '/query',
    component: 'layout.base$view.query',
    meta: {
      title: 'query',
      i18nKey: 'route.query'
    }
  }
];
